import { render, staticRenderFns } from "./StudentsEvaluationResultsTable.vue?vue&type=template&id=73b29d5e&"
import script from "./StudentsEvaluationResultsTable.vue?vue&type=script&lang=js&"
export * from "./StudentsEvaluationResultsTable.vue?vue&type=script&lang=js&"
import style0 from "./StudentsEvaluationResultsTable.vue?vue&type=style&index=0&id=73b29d5e&prod&scope=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports